/*
 * Barre de livraison gratuite du panier (thème Combine 2.4.3)
 * Version Café Public : ajoute un 2e palier « cadeau » (ex. 39 $ → 100 $).
 *
 * Les réglages viennent de la section « Barre à paliers (cadeau) » du gabarit Panier,
 * qui définit window.CafePublicPaliers. Sans cette section, le comportement d'origine
 * du thème est conservé tel quel (un seul palier, textes et montant du thème).
 */
if ( typeof ShippingNotice !== 'function' ) {

  const CP_PALIERS_DEFAULTS = {
    labelShipping: 'Livraison gratuite',
    labelGift: 'Cadeau',
    textBeforeGift: 'Vous avez la livraison gratuite au Québec. Plus que [montant] pour votre cadeau !',
    textDone: 'Bravo ! Votre cadeau est débloqué.'
  };

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {

      const textElement = this.querySelector('[data-js-free-shipping-text]');
      if ( ! textElement ) {
        return;
      }

      const sliderElement = this.querySelector('[data-js-free-shipping-slider]');
      const settings = this._settings();
      const config = window.CafePublicPaliers || null;
      const rate = ( window.Shopify && window.Shopify.currency && window.Shopify.currency.rate ) ? Number(window.Shopify.currency.rate) : 1;
      const cartTotal = Number(this.getAttribute('data-cart-total')) || 0;

      let freeShippingThreshold = Math.round(Number(this.getAttribute('data-free-shipping')) * rate);
      if ( config && Number(config.shippingAmount) > 0 ) {
        freeShippingThreshold = Math.round(Number(config.shippingAmount) * rate);
      }

      this._clearTiers();

      if ( config && Number(config.giftAmount) > 0 ) {
        const giftThreshold = Math.round(Number(config.giftAmount) * rate);
        if ( giftThreshold > freeShippingThreshold ) {
          this._renderTiers(config, settings, cartTotal, freeShippingThreshold, giftThreshold, textElement, sliderElement);
          return;
        }
      }

      // Comportement d'origine du thème : un seul palier (livraison gratuite)
      const freeShippingRemaining = cartTotal - freeShippingThreshold;
      let cartSliderWidth = 0;
      if ( freeShippingRemaining < 0 ) {
        textElement.innerHTML = String(settings.locales.shipping_notice_remaining_to_free || '').replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), settings.shop_money_format));
        cartSliderWidth = 100 - (Math.abs(freeShippingRemaining) * 100 / freeShippingThreshold);
      } else {
        textElement.innerHTML = settings.locales.shipping_notice_eligible_for_free || '';
        cartSliderWidth = 100;
      }
      if ( sliderElement ) {
        sliderElement.style.width = `${cartSliderWidth}%`;
      }

    }

    _settings() {
      const settings = ( window.KROWN && window.KROWN.settings ) ? window.KROWN.settings : {};
      if ( ! settings.locales ) {
        settings.locales = {};
      }
      return settings;
    }

    _renderTiers(config, settings, cartTotal, shippingThreshold, giftThreshold, textElement, sliderElement) {

      const shippingReached = cartTotal >= shippingThreshold;
      const giftReached = cartTotal >= giftThreshold;

      this.classList.add('cp-paliers');

      // Message au-dessus de la barre
      if ( ! shippingReached ) {
        const remaining = this._formatMoney(shippingThreshold - cartTotal, settings.shop_money_format);
        if ( config.textBeforeShipping ) {
          this._setMessage(textElement, config.textBeforeShipping, remaining);
        } else {
          textElement.innerHTML = String(settings.locales.shipping_notice_remaining_to_free || '').replace('{{ remaining_amount }}', remaining);
        }
      } else if ( ! giftReached ) {
        this._setMessage(textElement, config.textBeforeGift || CP_PALIERS_DEFAULTS.textBeforeGift, this._formatMoney(giftThreshold - cartTotal, settings.shop_money_format));
      } else {
        this._setMessage(textElement, config.textDone || CP_PALIERS_DEFAULTS.textDone, '');
      }

      // Barre : 0 → palier cadeau, avec un repère à chaque palier
      if ( sliderElement ) {

        sliderElement.style.width = `${Math.min(100, Math.max(0, cartTotal * 100 / giftThreshold))}%`;

        const track = sliderElement.parentElement;
        const shippingPosition = shippingThreshold * 100 / giftThreshold;

        track.appendChild(this._createDot(shippingPosition, shippingReached, false));
        track.appendChild(this._createDot(100, giftReached, true));

        const labels = document.createElement('span');
        labels.className = 'cp-paliers__labels';
        labels.setAttribute('aria-hidden', 'true');
        labels.appendChild(this._createLabel(shippingPosition, config.labelShipping || CP_PALIERS_DEFAULTS.labelShipping, this._formatShort(shippingThreshold, settings), shippingReached, false));
        labels.appendChild(this._createLabel(100, config.labelGift || CP_PALIERS_DEFAULTS.labelGift, this._formatShort(giftThreshold, settings), giftReached, true));
        track.insertAdjacentElement('afterend', labels);

      }

      // Lien facultatif, affiché une fois le cadeau débloqué
      if ( giftReached && config.linkUrl && config.linkLabel ) {
        const link = document.createElement('a');
        link.className = 'cp-paliers__link';
        link.href = config.linkUrl;
        link.textContent = config.linkLabel;
        this.appendChild(link);
      }

    }

    _clearTiers() {
      this.classList.remove('cp-paliers');
      this.querySelectorAll('.cp-paliers__dot, .cp-paliers__labels, .cp-paliers__link').forEach(element => element.remove());
    }

    _createDot(position, reached, isEnd) {
      const dot = document.createElement('span');
      dot.className = 'cp-paliers__dot' + ( isEnd ? ' cp-paliers__dot--end' : '' ) + ( reached ? ' is-reached' : '' );
      dot.style.left = `${position}%`;
      dot.setAttribute('aria-hidden', 'true');
      return dot;
    }

    _createLabel(position, name, amount, reached, isEnd) {
      const label = document.createElement('span');
      let className = 'cp-paliers__label';
      if ( isEnd ) {
        className += ' cp-paliers__label--end';
      } else {
        label.style.left = `${position}%`;
        if ( position < 22 ) {
          className += ' cp-paliers__label--start';
        }
      }
      if ( reached ) {
        className += ' is-reached';
      }
      label.className = className;
      const nameElement = document.createElement('span');
      nameElement.textContent = name;
      const amountElement = document.createElement('span');
      amountElement.textContent = amount;
      label.appendChild(nameElement);
      label.appendChild(amountElement);
      return label;
    }

    // Insère le message en texte brut ; [montant] (ou {{ remaining_amount }}) devient le montant en gras
    _setMessage(element, template, amount) {
      element.textContent = '';
      const plainAmount = this._plain(amount);
      String(template).split(/\[montant\]|\{\{\s*remaining_amount\s*\}\}/).forEach((part, index) => {
        if ( index > 0 ) {
          const strong = document.createElement('strong');
          strong.textContent = plainAmount;
          element.appendChild(strong);
        }
        if ( part ) {
          element.appendChild(document.createTextNode(part));
        }
      });
    }

    // Montant court pour les repères : « 39 $ » plutôt que « 39,00 $ »
    _formatShort(cents, settings) {
      const format = settings.shop_money_format || '${{amount}}';
      if ( cents % 100 === 0 ) {
        return this._plain(format.replace(/\{\{\s*(\w+)\s*\}\}/, String(cents / 100) + ( settings.iso_code || '' )));
      }
      return this._plain(this._formatMoney(cents, format));
    }

    _plain(html) {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = String(html).replace(/<[^>]*>/g, '');
      return decoder.value;
    }

    _formatMoney(cents, format) {

      if ( typeof cents === 'string' ) {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '${{amount}}';
      const isoCode = ( window.KROWN && window.KROWN.settings && window.KROWN.settings.iso_code ) ? window.KROWN.settings.iso_code : '';

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if ( isNaN(number) || number === null ) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount + isoCode;
      }

      const match = formatString.match(placeholderRegex);

      switch ( match ? match[1] : 'amount' ) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);

    }

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}
